import { render, staticRenderFns } from "./PreAtendimentoView.vue?vue&type=template&id=737e5095&"
import script from "./PreAtendimentoView.vue?vue&type=script&lang=js&"
export * from "./PreAtendimentoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports